import { AdministratorSerializer } from './administrator.serializer';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PaginationStoreService } from '@core/resources/pagination.service';
import { ResourceService } from '@core/resources/resource.service';
import { Observable } from 'rxjs/internal/Observable';
import { ADMIN_CONFIG, AdminToken, Administrator } from './administrator';
import { EnvironmentService } from '@core/domains/environment/environment.service';
import { map } from 'rxjs';
import { RoleAdmin } from '../adminMe/admin-me';

export interface AdminPayload {
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: RoleAdmin;
}

export interface ActivationPayload {
  email: string;
}

export interface EnableAdminPayload {
  is_enabled: boolean;
}

@Injectable()
export class AdministratorService extends ResourceService<Administrator> {

  constructor(
    protected env: EnvironmentService,
    protected http: HttpClient,
    protected override pageStore: PaginationStoreService,
    @Inject(ADMIN_CONFIG) private config: AdminToken
  ) {
    super(
      env,
      http,
      'auth',
      'admins/v2',
      new AdministratorSerializer,
      pageStore
    );
  }

  public override create(item: unknown): Observable<Administrator> {
    return this.httpClient
      .post<Administrator>(`${this.baseUrl}/admins/${this.config.api}/`, item)
      .pipe(map((response: unknown) => this.convertDatum(response)));
  }

  resendActivation(payload: ActivationPayload): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/admins/${this.config.api}/resend_activation/`, payload);
  }
}
